import _ from 'lodash';
import cookie from 'js-cookie';
import PropTypes from 'prop-types';
import { translate } from 'react-multi-lang';
import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import SponsoredChip from '../../Chip/SponsoredChip';
import { getUserId } from '../../../helpers/storage/user';
import { getBaseUrl } from '../../../helpers/constants/resource';
import { AdCampaignPlacementType } from '../../../helpers/constants/ads';
import AdImpressionService from '../../../helpers/services/ads/ad-impressions';

import "../../Hub/styles/index.css"
import "../../LandingPageIndex/Login.scss"
import "../../../../src/components/Accounts/Profile/Profile.scss";
import "../../Model/PerformerProfile/components/UserAboutView.css";
import DoubleRightArrowIcon from '../../../images/icons/double-right-arrow.svg?react'

const AdBannerCard = ({ data, isPreview }) => {
  const { ref, inView } = useInView({
    threshold: 0.5, // Trigger when 50% of the component is visible
    triggerOnce: true
  });

  const handleAction = async () => {
    if (data.impression && !isPreview) {
      AdImpressionService.createEvent({
        event: "click",
        user_id: getUserId(),
        ad_impression_id: data.impression?.id,
        cookie: JSON.stringify(cookie.get()),
        page_url: getBaseUrl() + window.location.pathname.substring(1),
      })
    }
    if (data?.redirect_link) window.open(data?.redirect_link, "_blank");
  }

  useEffect(() => {
    if (inView && data && !data.impression && !data.isInprogress && !isPreview) {
      data.isInprogress = true
      AdImpressionService.create({
        ad_campaign_id: data?.id,
        user_id: getUserId(),
        cookie: JSON.stringify(cookie.get()),
        page_url: getBaseUrl() + window.location.pathname.substring(1),
        placement: AdCampaignPlacementType.LANDING_PAGE_SPONSORED_HIGHLIGHT,
      })
        .then((response) => data.impression = response.data)
        .catch((error) => console.error(error))
        .finally(() => data.isInprogress = false)
    }
  }, [inView, data])

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${data.ad_assets[0]?.preview_file || data.ad_assets[0]?.file})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#fff',
          borderRadius: '12px',
          padding: '40px 30px',
          marginX: 1,
          display: 'flex',
          width: {
            xs: '100%',
            md: '50%'
          },
          margin: 'auto',
          alignItems: 'center',
          justifyContent: 'flex-start',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid #ff0066',
        }}
        ref={ref}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: {
              xs: 'start',
              sm: 'center'
            },
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            gap: {
              xs: 5,
              sm: 3
            },
          }}
        >
          <Box
            sx={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              backgroundColor: '#000',
              backgroundImage: `url(${data?.logo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              border: '1px solid #ff0066',
            }}
          ></Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
              {data?.headline}
            </Typography>
            <Typography variant="h6">{data?.description}</Typography>
            <button onClick={handleAction} className={`button-primary w-100`}>
              {data?.action_label} <DoubleRightArrowIcon />
            </button>
          </Box>
        </Box>

        <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
          <SponsoredChip style={{ color: "white" }} />
        </Box>
      </Box>

    </>
  );
};

AdBannerCard.propTypes = {
  data: PropTypes.object,
  isPreview: PropTypes.bool,
};

export default translate(AdBannerCard);
